import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import { useT } from "@/lib/i18n";

export const SiteFooter = () => {
  const { t, anchor } = useT();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border bg-background" aria-labelledby="footer-title">
      <div className="container-x py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span aria-hidden className="inline-flex h-9 w-9 items-center justify-center rounded-lg" style={{ background: "hsl(var(--pine))", color: "hsl(var(--primary-foreground))" }}>
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 20l9-14 9 14z" />
                  <path d="M8 20v-5h8v5" />
                </svg>
              </span>
              <span id="footer-title" className="font-display text-xl font-semibold">{t.site?.name ?? t.brand.name}</span>
            </div>
            <p className="mt-3 text-sm text-muted-foreground max-w-md leading-relaxed">{t.footer.description}</p>
          </div>

          <div>
            <div className="kicker">{t.footer.navLabel}</div>
            <ul className="mt-3 space-y-2">
              {t.nav.map((l) => (
                <li key={l.href}>
                  <a href={anchor(l.href)} className="text-sm text-foreground/85 hover:text-foreground link-underline">{l.label}</a>
                </li>
              ))}
            </ul>
            {t.footer.pages?.length > 0 && (
              <>
                <div className="kicker mt-6">{t.footer.pagesLabel}</div>
                <ul className="mt-3 space-y-2">
                  {t.footer.pages.map((p) => (
                    <li key={p.href}>
                      <a href={p.href} className="text-sm text-foreground/85 hover:text-foreground link-underline">{p.label}</a>
                    </li>
                  ))}
                </ul>
              </>
            )}
          </div>

          <div>
            <div className="kicker">{t.footer.contactLabel}</div>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <a href={t.brand.phoneHref} className="inline-flex items-center gap-2 text-foreground/85 hover:text-foreground" data-testid="footer-phone">
                  <Phone className="h-3.5 w-3.5" /> {t.brand.phone}
                </a>
              </li>
              <li>
                <a href={t.brand.emailHref} className="inline-flex items-center gap-2 text-foreground/85 hover:text-foreground" data-testid="footer-email">
                  <Mail className="h-3.5 w-3.5" /> {t.brand.email}
                </a>
              </li>
              <li className="pt-1">
                <div className="inline-flex items-start gap-2 text-muted-foreground">
                  <MapPin className="h-3.5 w-3.5 mt-0.5" />
                  <address className="not-italic">
                    {t.brand.address.line1}<br />
                    {t.brand.address.city}<br />
                    {t.brand.address.country}
                  </address>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-border flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <p className="text-xs text-muted-foreground">© {year} {t.footer.legalLine ?? t.brand.name}. {t.footer.rights}</p>
          <p className="text-xs text-muted-foreground">{t.footer.strap}</p>
        </div>
      </div>
    </footer>
  );
};
